import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="none" fillRule="evenodd"><path d="M0 0h16v16H0z" /><path fill="currentColor" fillRule="nonzero" d="M6.562 8l6.364 6.223L11.108 16 2.926 8l8.182-8 1.818 1.777z" /></g></svg>);